export default "__VITE_ASSET__GrPQ2tcL__"